import React, { useEffect } from 'react';
import { IOrderSale, REQUIRE_INVOICE_CODE } from '../../order-sale-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { RHTextField } from '../../../../../../../dum';
import { useOrderSaleOrderSaleReceiptTypeInputQuery } from '../../../../../../../../services';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function InvoiceCodeInput() {
    const INPUT_NAME: keyof IOrderSale = 'invoice_code';
    const { data } = useOrderSaleOrderSaleReceiptTypeInputQuery();
    const { getValues, setValue } = useFormContext<IOrderSale>();
    const requireInvoiceCode = useWatch({
        name: REQUIRE_INVOICE_CODE,
    }) as IOrderSale['require_invoice_code'];
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IOrderSale['receipt_type_id'];
    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );
    const isNonTaxableReceipt = !!receiptType && !receiptType.applies_tax;

    useEffect(() => {
        if (
            !requireInvoiceCode &&
            !isNonTaxableReceipt &&
            getValues(INPUT_NAME) !== 0
        ) {
            setValue(INPUT_NAME, 0, {
                shouldDirty: true,
                shouldValidate: true,
            });
        }
    }, [getValues, isNonTaxableReceipt, requireInvoiceCode, setValue]);

    return (
        <RHTextField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.invoice_code)}
            disabled={!requireInvoiceCode || isNonTaxableReceipt}
        />
    );
}
